import * as tslib_1 from "tslib";
import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import SheetUpload from "./import/data-upload.vue";
import DataImport from "./import/data-import.vue";
import DataImportStatus from "./import/data-import-status.vue";
import { listParams } from "@cloudpivot/api";
// import { FormSheetControl } from "../../../controls";
import { UploadControl } from "@cloudpivot/form/src/common/controls/upload-control";
import { Button, Modal } from "@h3/antd-vue";
let Import = class Import extends Vue {
    constructor() {
        super(...arguments);
        this.simulateInterval = -1;
        /**
         * 子表导入,导出代码
         *
         */
        this.modalVisible = true;
        this.isInitView = true;
        this.canImport = false;
        this.isUploading = false;
        this.importFileName = "";
        this.importPercent = 0;
        this.successNum = 0;
        this.failNum = 0;
        this.isImportEnd = false;
        this.isImporting = false;
        this.errorFile = "";
        this.showModal = false;
        this.getSheetImportCount = { select: 0, radio: 0, checkbox: 0 };
        // sheetParams:any = {}
        this.importSize = 0; //子表Excel导入超出上限，后端返回的配置值
        this.importStatus = listParams.ImportResult.None;
        this.uploadCompleteStatus = false; // 是否有文件
    }
    importSheet() {
        this.showModal = true;
    }
    get sheetParams() {
        // const formStatus:any = {
        //   'DRAFT': 0,
        //   'PROCESSING': 1,
        //   'CANCELLED': 2,
        //   'COMPLETED': 3
        // }
        // const params:any = Object.assign({},this.params);
        // params.sequenceStatus = formStatus[params.sequenceStatus];
        return this.params;
    }
    get showUploadModel() {
        return this.isInitView;
    }
    get showConfirmButton() {
        return (this.importStatus === listParams.ImportResult.DataNumExceed ||
            this.importStatus === listParams.ImportResult.DataColumnError ||
            this.importStatus === listParams.ImportResult.PartialSuccess);
        // return this.failNum > 0 || this.failMessage || this.columnMatchError;
    }
    get showImportStatus() {
        return (!this.isImporting &&
            !this.isInitView);
    }
    get showReImportButton() {
        // return this.networkError;
        return this.importStatus === listParams.ImportResult.SystemError;
    }
    // 取消按钮
    get showCancelButton() {
        return (this.isInitView ||
            this.importStatus === listParams.ImportResult.SystemError);
    }
    //  get showImportModel() {
    //   return this.isImporting;
    // }
    changeImportBtnStatus(status) {
        this.canImport = status;
    }
    setImportFileName(fileName) {
        this.importFileName = fileName;
    }
    get getCanImport() {
        return this.canImport && this.uploadCompleteStatus;
    }
    // 上传完成
    uploadComplete(val) {
        this.uploadCompleteStatus = val;
    }
    /**
     * 数据导出
     */
    confirmImport() {
        const bizObjectData = this.getImportFormValue();
        bizObjectData['id'] = this.params.id;
        this.isInitView = false;
        this.isUploading = false;
        const formStatus = {
            DRAFT: 0,
            PROCESSING: 1,
            CANCELLED: 2,
            COMPLETED: 3,
        };
        const params = Object.assign({}, this.params);
        params.fileName = this.importFileName;
        params.sequenceStatus = formStatus[params.sequenceStatus];
        const { startWorkflowCode } = this.$route.query;
        if (startWorkflowCode)
            params.startWorkflowCode = startWorkflowCode;
        params.bizObjectData = bizObjectData;
        // 
        this.simulateImport();
        UploadControl.service.getSheetDetail(params).then((res) => {
            if (res.errcode !== 0) {
                this.isImporting = false;
                this.importStatus = listParams.ImportResult.SystemError;
            }
            // else if (res.errcode === 0 && res.data.operationResult) {
            //   this.isImporting = false;
            //   this.$emit('repeatErrorHandle',res.data.data);
            // }
            else {
                this.isImporting = false;
                this.errorFile = res.data.fileName;
                const data = res.data.data;
                //  this.$emit('repeatErrorHandle',res.data);
                if (res.data.secondImportData && res.data.secondImportData.length > 0) {
                    this.$emit("repeatErrorHandle", res.data);
                    return;
                }
                this.getSheetImportCount = {
                    select: res.data.dropdownMarkedCount,
                    radio: res.data.radioMarkedCount,
                    checkbox: res.data.checkboxMarkedCount,
                };
                // 
                // 导入数据回调
                if (data) {
                    this.$emit("importFinishe", data);
                }
                this.importStatus = res.data.errorType;
                this.successNum = res.data.successCount;
                this.failNum = res.data.errorCount;
                //根据导入数据量超出上限时，获取配置的最大值
                if (this.importStatus === 3) {
                    this.importSize = res.data.errorMsg;
                }
                else {
                    this.importSize = 0;
                }
            }
        });
    }
    /**
     * 模拟导入处理进度
     */
    simulateImport() {
        let percent = 1;
        this.simulateInterval = setInterval(() => {
            if (!this.isImportEnd) {
                if (percent <= 90) {
                    percent += this.random(5);
                    this.importPercent = percent;
                }
            }
            else {
                clearInterval(this.simulateInterval);
            }
        }, 100);
    }
    /**
     * 产生随机整数
     */
    random(num) {
        return Math.ceil(Math.random() * 5);
    }
    /**
     * 导入结束（不管成功与失败）
     */
    importEnd(data) {
        // 此处需要定义数据结构
        clearInterval(this.simulateInterval);
        // 
        this.isImporting = false;
        this.isImportEnd = true;
        this.importFileName = data.fileName;
        this.successNum = data.successCount;
        this.failNum = data.errorCount;
        this.importStatus = data.errorType;
    }
    reset() {
        clearInterval(this.simulateInterval);
        this.isInitView = true;
        this.isUploading = false;
        this.isImporting = false;
        this.importPercent = 0;
        this.isImportEnd = false;
        this.successNum = 0;
        this.failNum = 0;
        this.canImport = false;
        this.importStatus = listParams.ImportResult.None;
        this.$emit("cancel");
    }
    /**
     * reset
     */
    handleCancel() {
        this.showModal = false;
        // this.$emit('cancel');
        this.reset();
    }
    /**
     * 重新导入
     */
    reImport() {
        this.reset();
    }
};
tslib_1.__decorate([
    Prop()
], Import.prototype, "params", void 0);
tslib_1.__decorate([
    Prop()
], Import.prototype, "visible", void 0);
tslib_1.__decorate([
    Prop()
], Import.prototype, "sheet", void 0);
tslib_1.__decorate([
    Inject({
        default: () => () => { },
    })
], Import.prototype, "getImportFormValue", void 0);
Import = tslib_1.__decorate([
    Component({
        name: "dataimport",
        components: {
            AButton: Button,
            AModal: Modal,
            SheetUpload,
            DataImport,
            DataImportStatus,
        },
    })
], Import);
export default Import;
